<template>
  <div class="history-modules-container">

    <div class="history-modules">

        <div class="d-flex header-history pt-3">
            <div class="col-3 maintitle d-flex justify-content-center align-items-center w-auto">سوابق خرید های من</div>
            <a :href="`https://wa.me/${support_phone}?text=${encodeURI('پشتیبانی')}`" target="_blank" class="col-2 p-2 mr-1 whatsapplink d-flex justify-content-center align-items-center w-auto">پشتیبانی واتساپ</a>
        </div>

          <div class="order-container d-flex flex-column mt-4 p-3" v-if="orders.length >0">

            <div v-for="orderitem in orders">
            <history-item :orderitem="orderitem"></history-item>
            </div>

          </div>

          <div class="order-container d-flex flex-column mt-4 p-3" v-else-if="loading === false">
            <div class="order-item mb-2 text-center">
              هیچ آیتمی برای نمایش وجود ندارد
            </div>
          </div>

          <div class="order-container d-flex flex-column mt-4 p-3" v-else>
            <div class="order-item mb-2 text-center">
                  در حال دریافت اطلاعات ...
            </div>
          </div>

    </div>

  </div>

</template>

<script>
import store from "@/store";
import HistoryItem from './History-item';
export default {
  data() {
    return {
      orders:[],
      support_phone:null,
      loading:false
    };
  },
  created() {
    this.getOrders();
  },
  components:{
    HistoryItem
  },
  computed: {

  },
  methods: {
    async getOrders(){
      this.loading = true;
      let fd = new FormData();
      fd.append("token", store.state.login.loginTempToken);

      // const response = await axios.post(
      //   "https://kishoto.ir/dtr/approid/web/get_profile",
      //   fd
      // );

      const response = await this.$ApiServiceLayer.post("packages_orders", fd);

      if (response.status_code === 200) {

        this.orders = response.list;
        this.loading = false;
        console.log(this.orders);

        this.support_phone = response.support_phone.replace("+","");
      } else {
        this.$toast.open({
          message: 'مشکلی در دریافت اطلاعات پیش آمده است',
          type: 'error',
        });
        this.loading = false;
      }
    },



  },
};
</script>

<style lang="scss" scoped>
.history-modules-container{
  width: 100%;
  height: 100%;
  .history-modules {
    width: 100%;
    height: 100%;
    background-image: url("~@/assets/img/bg/profile_history.jpg");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    position: fixed;
    top: 0;
    left: 0;
    overflow-y: auto;

    .header-history{

      .maintitle{
        background: #F44336;
        color:#ffffff;
        border-radius: 0 12px 12px 0px;
        height: 45px;
        padding-left: 35px !important;
        padding-right: 14px !important;
        margin-right: 12px;
        font-size: 17px;
      }
      .whatsapplink{
        background: #8BC34A;
        color:#ffffff;
        border-radius:8px;
        height: 45px;
        font-size: 17px;
        text-decoration: none;
      }
    }


  }
}
</style>
